import * as LowcompIndex from 'lowcomp/plugins/index-series/indexS';
import { MemberTimeProvider } from 'lowcode/utils/context/memberTimeZone';
import MemberGloData from 'lowcode/utils/MemberGloData';
import Product from 'lowcode/pages/product';
import { EcoProvider } from 'lowcode/utils/context/ecocredits';
import { queryEditorDetailOnline } from 'lowcode/utils/service';
import * as LowcompMember from 'lowcomp/plugins/member/indexS';
import type { GetServerSidePropsContext, NextPage } from 'next';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/appreciation-day';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';

// import MonthlyCompoment from '@/components/EcocreditsMonthlyMadness';
// import { MonthlyProvider } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';
import getLocal from '@/app/utils/getLocal';
import { IPageStatus } from '@/components/EcocreditsMonthlyMadness/type';
import { onLogin } from '@/utils/cookie';
import { useLang } from '@/i18n';
import efBridge from '@/utils/JSBridge';
import './index.scss';
import { getAppSession } from '@/utils/appGetToken';

const allTemp = {
    ...LowcompIndex,
    ...LowcompMember,
};

// AppreciationDay
const EcocreditsMonthlyMadness: NextPage = ({ isLogin, SEO, ecocreditsData, status, debug, id, data, localDebugTime }: any) => {
    const { t } = useLang('ecocredits');
    const { isApp } = useGlobal();
    const { locale } = getLocal();

    if (isApp) {
        // efBridge.registerHandler('getAppMsg', (res) => {
        //     if (!res) return;
        //     const dataSet = {
        //         token: res.token.replace('Bearer ', ''),
        //         user: {},
        //     };
        //     onLogin(dataSet);
        // });
        const token = getAppSession();
        const dataSet = {
            token,
            user: {},
        };
        onLogin(dataSet);
    }

    const initState = {
        isLogin: isApp ? true : isLogin,
        timeLine: ecocreditsData.timeLine,
        protocol: ecocreditsData.protocol,
        pageStatus: status || IPageStatus.TEASER,
        localDebugTime: localDebugTime || undefined, // 时间debug参数
    };

    const isDebug = debug && Object.values(IPageStatus).includes(debug);

    if (isDebug) {
        initState.pageStatus = debug;
    }

    // const IS_PROD: boolean = process.env.NEXT_PUBLIC_MODY === 'prd';
    // // 代码写死的非配置化站点
    // const IS_FIX_SITES: boolean = ['us', 'ca'].includes(locale);

    return (
        <>
            <SEO title={t('seo.title') || t('join_title')} description={t('seo.desc')} />
            <SEOlinksA locale={String(locale)} list={['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'kr', 'nl']} pathname={seoconfig.url} />
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2132;
                    }
                    .glo-editor-modal-show {
                        z-index: 2133;
                    }
                `}
            </style>
            <PageLayout isNoFixed>
                {/* {IS_FIX_SITES ? (
                    <MonthlyProvider state={initState}>
                        <MonthlyCompoment />
                    </MonthlyProvider>
                ) : (
                    <EcoProvider>
                        <Product id={id} data={data} allTemp={allTemp} />
                    </EcoProvider>
                )} */}
                <MemberTimeProvider>
                    <MemberGloData isOpenA={true} />
                    <EcoProvider>
                        <Product id={id} data={data} allTemp={allTemp} />
                    </EcoProvider>
                </MemberTimeProvider>
            </PageLayout>
        </>
    );
};

export default EcocreditsMonthlyMadness;

export async function getServerSideProps({ locale, req, query }: GetServerSidePropsContext) {
    const naList = ['us', 'ca'];
    const euList = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'];
    const whiteLocaleList = naList.concat(euList);
    whiteLocaleList.push('jp');
    whiteLocaleList.push('kr');
    whiteLocaleList.push('za');
    whiteLocaleList.push('au');
    // 包含 timeLine
    let ecocreditsData = null;
    try {
        ecocreditsData = require(`@/data/ecocredits/${locale}.js`);
    } catch (err) {
        ecocreditsData = require(`@/data/ecocredits/index.js`);
        throw new Error('读取/data/ecocredits/index.js失败');
    }
    // 时间节点判断 正式环境未开始重定向404
    const { debug, localDebugTime } = query;
    const time = new Date().getTime();
    // if (process.env.NEXT_PUBLIC_MODY === 'prd') {
    //     if (time < ecocreditsData.timeLine?.teaser.start && !debug) {
    //         return redirectTo404();
    //     }
    //     debug = '';
    // }

    // 当前阶段
    let status: IPageStatus | null = IPageStatus.TEASER;
    if (ecocreditsData.timeLine) {
        if (time < ecocreditsData.timeLine.teaser.start) {
            status = null;
        } else if (time < ecocreditsData.timeLine.teaser.end) {
            status = IPageStatus.TEASER;
        } else if (time < ecocreditsData.timeLine.activity.end) {
            status = IPageStatus.ACTIVITY;
        } else {
            status = null;
        }
    }

    // kr只有activity阶段，单独判断
    // if (ecocreditsData.timeLine && locale === 'kr') {
    //     if (time > ecocreditsData.timeLine.activity.start && time < ecocreditsData.timeLine.activity.end) {
    //         status = IPageStatus.ACTIVITY;
    //     } else {
    //         status = null;
    //     }
    // }

    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    // 结束后重定向到 ecocredits页面 (不是预热也不是活动阶段)， 产品说去掉，配合配置化页面
    // if (!status && !debug && naList.includes(locale as string)) {
    //     return {
    //         redirect: {
    //             destination: `/${locale}/ecocredits`,
    //             permanent: true,
    //         },
    //     };
    // }

    // jp 为配置页面
    let data = {
        thePage: {},
        theTemp: [],
        theData: {},
        theAttr: {},
        sqlData: {},
    };
    const id = 'ecocredits-monthly-madness';
    try {
        data = await queryEditorDetailOnline(id, locale as string);
    } catch (e: any) {}

    // 获取登陆信息
    const userInfoJson = req.cookies?.userInfo || '';
    let isLogin = false;
    try {
        const userInfo = JSON.parse(userInfoJson);
        isLogin = !!userInfo.token;
    } catch {}

    return {
        props: {
            isLogin,
            ecocreditsData,
            status,
            debug: debug || '',
            id,
            data,
            localDebugTime: localDebugTime || '',
        },
    };
}
